import React from "react";
import Select from "react-select";
import Label from "./label.jsx";
import momentTimezone from "moment-timezone";

class TimezoneField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      now: momentTimezone()
    };

    this.updateTime = this.updateTime.bind(this);
  }

  updateTime() {
    this.setState({
      now: momentTimezone()
    });
  }

  componentDidMount() {
    this.timezoneInterval = setInterval(this.updateTime, 1000);
    this.updateTime();
  }

  componentWillUnmount() {
    clearInterval(this.timezoneInterval);
  }

  render() {
    const { label, labelStyle, style, value, onChange } = this.props;
    const { now } = this.state;

    return (
      <div style={style}>
        {label && <Label style={labelStyle}>{label}</Label>}
        <Select
          placeholder="No timezone selected"
          value={value}
          autosize={true}
          options={momentTimezone.tz.names().map(n => {
            return {
              label: `${n} (${now.tz(n).format("LTS")})`,
              value: n
            };
          })}
          onChange={option => {
            onChange(option ? option.value : "");
          }}
        />
      </div>
    );
  }
}

export default TimezoneField;



// WEBPACK FOOTER //
// ./src/app/components/partials/timezone-field.jsx